import { render, staticRenderFns } from "./UsersAndPermissions.vue?vue&type=template&id=38bed97d&"
import script from "./UsersAndPermissions.vue?vue&type=script&lang=js&"
export * from "./UsersAndPermissions.vue?vue&type=script&lang=js&"
import style0 from "./UsersAndPermissions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports